// angular
import { CommonModule, NgClass } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  input,
  OnChanges,
  ViewChild,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// pipes
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';

@Component({
  selector: 'pwj-simple-video-box',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    TranslateDataPipe,
    NgClass,
  ],
  templateUrl: './simple-video-box.component.html',
  styleUrl: './simple-video-box.component.scss',
})
export class SimpleVideoBoxComponent implements AfterViewInit, OnChanges {
  public hiddenPlayBtn: boolean = false;

  // inputs
  playBtnText = input<string>('play');
  btnsClass = input<string>();
  videoPreviewSrc = input.required<string>();
  disableBtn = input<boolean>(false);
  playBtnSize = input<'small' | 'large'>('large');

  @ViewChild('videoElement') videoElement!: ElementRef;

  ngAfterViewInit() {
    if (this.videoElement) {
      this.videoElement.nativeElement.addEventListener('play', (event: any) => {
        this.hiddenPlayBtn = true;
      });

      this.videoElement.nativeElement.addEventListener(
        'pause',
        (event: any) => {
          this.hiddenPlayBtn = false;
        }
      );
    }
  }

  ngOnChanges(): void {
    if (this.videoElement) {
      this.hiddenPlayBtn = false;
    }
  }

  public playVideo(videoElement: HTMLVideoElement) {
    if (!this.disableBtn()) {
      videoElement.play();
      this.hiddenPlayBtn = true;
    }
  }

  public pauseVideo(videoElement: HTMLVideoElement) {
    if (!this.disableBtn()) {
      videoElement.pause();
    }
  }
}
